import { configureStore } from "@reduxjs/toolkit";
import applicationReducer from "./slice/rfpModuleSlice/application";
import overviewReducer from "./slice/rfpModuleSlice/overview";
import templatesReducer from "./slice/rfpModuleSlice/templates";
import evaluationReducer from "./slice/rfpModuleSlice/evaluation";
import buildReducer from "./slice/rfpModuleSlice/build";
import rfpReducer from "./slice/rfpModuleSlice/rfp";
import summaryReducer from "./slice/rfpModuleSlice/summary";
import timelineReducer from "./slice/rfpModuleSlice/timeline";
import dashboardReducer from "./slice/rfpModuleSlice/dashboard";
import subscriptionReducer from "./slice/rfpModuleSlice/subscription";
import adminDashboardReducer from "./slice/rfpModuleSlice/adminDashboard";
import hrFlowReducer from "./slice/hrModuleSlice/hrFlow";
import hrApplicationsReducer from "./slice/hrModuleSlice/hrApplicationsSlice";

export const store = configureStore({
  reducer: {
    applicationData: applicationReducer,
    overviewData: overviewReducer,
    templatesData: templatesReducer,
    evaluationData: evaluationReducer,
    buildData: buildReducer,
    rfpData: rfpReducer,
    summaryData: summaryReducer,
    timelineData: timelineReducer,
    dashboardData: dashboardReducer,
    subscriptionData: subscriptionReducer,
    adminDashboardData: adminDashboardReducer,
    hrFlowData: hrFlowReducer,
    hrApplicationsData: hrApplicationsReducer,
    },
});

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;